import { render, staticRenderFns } from "./performanceCheck.vue?vue&type=template&id=b2163e48&scoped=true"
import script from "./performanceCheck.vue?vue&type=script&lang=js"
export * from "./performanceCheck.vue?vue&type=script&lang=js"
import style0 from "./performanceCheck.vue?vue&type=style&index=0&id=b2163e48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2163e48",
  null
  
)

export default component.exports